import React, { memo, useCallback } from "react";
import { NodeResizer, Position, useReactFlow } from '@xyflow/react';
import OneToOneHandle from "../handles/OneToOneHandle";
import NodeModal from "../modal/NodeModal";
import { ButtonMore } from "../../buttonMore/buttonMore";
import { ConfirmModal } from "../../confirm/ConfirmModal";

const StartNode = ({id, data, selected}) => {
  const { updateNodeData, setNodes } = useReactFlow();

  const handleDelete = useCallback(() => {
    setNodes((nodes) => nodes.filter((node) => node.id !== id));
  }, [id, setNodes]);

  const handleChange = useCallback((evt) => {
    updateNodeData(id, {value: evt.target.value});
  }, [id, updateNodeData]);

  const handleChangeData = useCallback((item) => {
    updateNodeData(item.id, item.data);
  }, [updateNodeData]);


  return (
    <>
      <NodeResizer
        color="#ff0071"
        isVisible={selected}
        minWidth={220}
        minHeight={100}
      />
      <div className="react-flow_card">
      <div className="node-card">
        <div className="node-content">
          <OneToOneHandle type="source" position={Position.Bottom} id="start" />
          <div className="node-header-right">
            <ButtonMore>
              <ul className="dropdown">
                <NodeModal trigger={<li className="dropdown__item icon-edit"><span>{data?.disabled ? 'Просмотр' : 'Редактировать'}</span></li>}
                  triggerWrap={false}
                  itemID={id} 
                  type={"StartNode"} 
                  data={data} 
                  handleOk={handleChangeData} />

                {!data?.disabled && <ConfirmModal trigger={<li className="dropdown__item icon-delete"><span>Удалить</span></li>} triggerWrap={false} title={"Удалить блок?"} handleOk={() => handleDelete()}/>}
              </ul>
            </ButtonMore>
          </div>
          <div className="node-header">
            Старт
          </div>
          
          <div className="node-description">
            <input
              type="text"
              name="value"
              value={data?.value || ''}
              onChange={handleChange}
              className="input"
            />
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default memo(StartNode);
